import { useEffect, useRef } from 'react';

import {
  BANK_CODES_FOR_ALL_MAP,
  getOrganizationLogoForAll,
  BankCodesForAll,
  getAllBankName,
} from '@revenuemarket/bank';
import { Flex } from '@revenuemarket/cds';
import { Select, SelectProps, Typography } from 'antd';
import Image from 'next/image';

interface Props extends SelectProps {
  value?: number;
  onChange: (value: number) => void;
  open: boolean;
}

const BankSelector: React.FC<Props> = ({ value, onChange, open, ...props }) => {
  const bankCodesArray = Array.from(BANK_CODES_FOR_ALL_MAP.keys());
  const selectRef = useRef<any>(null);

  useEffect(() => {
    if (open && selectRef.current) {
      selectRef.current.focus();
    }
  }, [open]);
  return (
    <Select
      showSearch
      filterOption={(input, option) => {
        return getAllBankName(option?.value as BankCodesForAll).includes(input);
      }}
      open={open}
      style={{ width: '100%' }}
      bordered={false}
      value={value}
      onChange={(value) => {
        onChange(value);
      }}
      ref={selectRef}
      options={bankCodesArray.map((code) => {
        return {
          label: (
            <Flex align="center" gap={8}>
              <Image
                width={20}
                height={20}
                src={
                  getOrganizationLogoForAll(code as BankCodesForAll)?.x2 ||
                  'https://static.clobe.ai/image/etc-bank.png'
                }
                alt={code}
              />
              <Typography.Text>{getAllBankName(code as BankCodesForAll)}</Typography.Text>
            </Flex>
          ),
          value: code,
        };
      })}
      {...props}
    />
  );
};

export default BankSelector;
